import { PlayerEnvironment } from "../player_environment";
import VideoHelpers from './../utils/video_helpers';
import CookieUtils from '../utils/cookie_utils';
import UserSession from '../utils/user_session'
import { PlayerAhoyEvent } from "../player_ahoy_event";
import BlockerButton from "../service/blocker/button";

export default class Adult {
  static runPlugin(options) {
    if (options.enable) {
      const adult = new Adult(options);
      adult.checkUserSession();
    }
  }

  constructor(options = {}) {
    this._player = options.player;
    this._testMode = options.testMode;
    this._data = options.data;
    this._userId = undefined;
    this._blocker = options.blocker;
  }

  player() {
    return this._player;
  }

  data() {
    return this._data;
  }

  testMode() {
    return this._testMode;
  }

  userId() {
    return this._userId;
  }

  blocker() {
    return this._blocker;
  }

  checkUserSession() {
    if (window.currentUser === undefined) {
      const notice = Adult.createAdultNotice();
      this.player().el().appendChild(notice);
      document.addEventListener('user.data.loaded', () => {
        const currentUser = UserSession.userId();
        notice.parentNode.removeChild(notice);
        this.init(currentUser);
      })
    } else {
      this.init(UserSession.userId());
    }
  }

  init(userId) {
    if (Adult.shouldSkipAdultBlocker()) {
      Adult.setAdultConfirmId(userId);
      return;
    }

    const adultConfirmId = CookieUtils.getCookie('adult_confirm_id');
    const userIsLogin = userId !== undefined;
    const userHasConfirm = Adult.userHasConfirm(userId, adultConfirmId);

    if ((!userIsLogin) || (userIsLogin && !userHasConfirm)) {
      Adult.createAdultBlocker(this.player(), userId, this.data(), this.blocker());
      Adult.sendEvent(this.data());
    }
  }

  static shouldSkipAdultBlocker() {
    return PlayerEnvironment.locationSearch().includes('pb_sac');
  }

  static createAdultBlocker(player, userId, data, blocker) {
    const vod_player = document.querySelector('#' + data.playerId());
    if (vod_player)
      vod_player.classList.add(
        'video-js',
        'vjs-fluid',
        'vod-player-dimensions'
      );

    const lang = VideoHelpers.getLang();
    const message = Adult.blockerContentCta(lang);
    const adultCallback = () => {
      let blockerElement = document.querySelector('.vjs-player-error__section');

      blockerElement.parentNode.removeChild(blockerElement);
      blocker.tech.error(null);
      blocker._isShown = false;
      player.tech().play();
      Adult.setAdultConfirmId(userId);
    }

    let ctaButtons = [];
    if (userId !== undefined) {
      const ctaButton = BlockerButton.createRevamp(
        'additionalWhiteCta-button',
        message.cta,
        adultCallback.bind(this)
      );
      ctaButtons.push(ctaButton);
    } else {
      const ctaButton = BlockerButton.createRevamp(
        'additionalWhiteCta-button',
        message.signInCta,
        blocker.onClickHrefButton.bind(this),
        { href: Adult.getSignInUrl() }
      );
      ctaButtons.push(ctaButton);
    }

    let element = blocker.renderBlocker2ButtonCta(message, 'adult', ctaButtons, false);
    element.classList.add('vjs-player-error__section--full')
    player.tech?.()?.pause?.();
    blocker.showMessage(element);
  }

  static createAdultNotice() {
    const notice = document.createElement("div");
    const preventClickPassThroughPlayer = (e) => {
      e.stopPropagation();
    };
    notice.className = "vjs-adult";
    notice.onclick = preventClickPassThroughPlayer;
    notice.ontouchend = preventClickPassThroughPlayer;

    return notice;
  }

  static setAdultConfirmId(userId) {
    const adultConfirmId = CookieUtils.getCookie('adult_confirm_id');

    if (adultConfirmId !== userId) {
      CookieUtils.setCookie('adult_confirm_id', userId, Adult.getAdultConfirmExpiry());
    }
  }

  static getSignInUrl() {
    const path = PlayerEnvironment.pathname();
    const search = PlayerEnvironment.locationSearch();

    return `/users/login?user_return_to=${path}${search}`;
  }

  static userHasConfirm(userId, adultConfirmId) {
    return userId == adultConfirmId;
  }

  static getAdultConfirmExpiry() {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);

    return expiryDate.toUTCString();
  }

  static blockerContentCta(lang) {
    const message = {
      id: {
        title: 'Konten dewasa dan sensitif',
        subtitle: 'Video ini berisi konten yang tidak sesuai untuk remaja dan anak-anak.',
        cta: 'Saya Sudah Dewasa',
        signInCta: 'Masuk',
      },
      en: {
        title: 'Adult and sensitive contents',
        subtitle: 'This video contains adult content which is not appropriate for teenagers and kids.',
        cta: 'I am an adult',
        signInCta: 'Sign In',
      },
    };

    return message[lang];
  }

  static sendEvent(data) {
    PlayerAhoyEvent.sendBlocker(
      data?.type()?.toLowerCase(),
      data?.isPremier(),
      data?.videoId(),
      'adult_confirm'
    );
  }
}
